import * as React from 'react';
import s from '../Cycles.scss';
import { Text } from '@wix/design-system';
import { Trans } from 'react-i18next';
import { InjectedExperimentsProps, withExperiments } from '@wix/wix-experiments-react';
import { RootStore, withInjectedRootStore } from 'providers';
import { calculateCycleRevShare } from 'utils';
import { CycleDetails } from 'types';
import { PremiumCurrencyFormatter } from '@wix/premium-react-text';

export interface RevShareHelperProps extends InjectedExperimentsProps {
    cycle: CycleDetails;
    rootStore: RootStore;
}

export const RevShareHelperComp: React.FC<RevShareHelperProps> = ({
    cycle,
    rootStore,
}) => {
    const { currentProduct, revShareData } = rootStore.appStore;
    if (!revShareData || !currentProduct) {
        return null;
    }
    const amountEarned = calculateCycleRevShare({ cycle, revShareData, productGuid: currentProduct.guid });
    return (
        <div className={s.revShareDisclaimer} data-hook='revshare-helper'>
            <Text
                weight='normal'
                size='small'
                dataHook='revshare-earnings'
            >
                <PremiumCurrencyFormatter
                    currencySettingsOverride={{ fractionSize: 2 }}
                    render={(formatCurrency) => (
                        <Trans
                            i18nKey='cycle_entry.yearly_multi.revshare.section_helper'
                            components={{
                                strong: <Text size='small' weight="bold" className={s.revShareAmount} />
                            }}
                            values={{
                                amountEarned: formatCurrency(amountEarned)
                            }}
                        />
                    )}
                />
            </Text>
        </div>
    );
};

export const RevShareHelper = withExperiments(withInjectedRootStore(RevShareHelperComp));
